import { render, staticRenderFns } from "./mfaVerification.vue?vue&type=template&id=e4cd46d4&"
import script from "./mfaVerification.vue?vue&type=script&lang=js&"
export * from "./mfaVerification.vue?vue&type=script&lang=js&"
import style0 from "./mfaVerification.vue?vue&type=style&index=0&id=e4cd46d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports